import type {
  ServiceGetAllResponse,
  ServiceGetByIdResponse,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { RolePermissionDataType } from './types'

const QUERY_KEY = (key?: string | Record<string, any>) =>
  ['pengguna', key] as const

const getAllPermission = (
  role_id: string
): ServiceQueryOptionType<ServiceGetByIdResponse<RolePermissionDataType>> => ({
  queryKey: QUERY_KEY(role_id),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetByIdResponse<RolePermissionDataType>
      >(`permissions/${role_id}`)

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const getAllRoles = (): ServiceQueryOptionType<
  ServiceGetAllResponse<Array<RolePermissionDataType>>
> => ({
  queryKey: QUERY_KEY({ type: 'roles' }),
  queryFn: async () => {
    try {
      const response =
        await api.get<ServiceGetAllResponse<Array<RolePermissionDataType>>>(
          '/roles'
        )
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
  ,
  // Roles sering dipanggil dari banyak komponen; jangan retry ketika gagal auth.
  retry: false
})

export const pengguna = {
  getAllPermission,
  getAllRoles
}
